import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-phone",
  "use": "icon-phone-usage",
  "viewBox": "0 0 18 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 25\" id=\"icon-phone\"><path d=\"M16.701 3.184v-.088c-.088-1.587-1.322-2.91-2.821-2.91H3.3C1.803.187.569 1.51.48 3.097v18.602c0 1.763 1.234 3.173 2.82 3.173h10.58c1.587 0 2.821-1.41 2.821-3.173V3.184ZM8.59 22.756c-.617 0-1.058-.441-1.058-1.058 0-.618.441-1.058 1.058-1.058s1.058.44 1.058 1.058c0 .617-.529 1.058-1.058 1.058Zm5.995-3.174H2.595V4.242h11.99v15.34Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol